export default "__VITE_ASSET__BMcqFHrD__"